import env from 'env';
import axios from 'axios';
import Qs from 'qs';

const qwApplianceManager = axios.create({
  baseURL: env.qwApplianceManagerBaseUrl,
  responseType: 'json',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

let store;

function select(state) {
  return state.account.user && state.account.user.accessToken;
}

function listener() {
  let token = select(store.getState());
  qwApplianceManager.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function setStore(s) {
  store = s;
  s.subscribe(listener);
}

export function getWebSocketURL() {
  return (
    env.qwApplianceManagerBaseUrl +
    '/socket/events?Authorization=' +
    qwApplianceManager.defaults.headers.common.Authorization
  );
}

export default qwApplianceManager;
